import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["stroke", "stroke-width"]
const _hoisted_3 = ["stroke", "stroke-width"]
const _hoisted_4 = ["stroke", "stroke-width"]



const __default__ = {
  name: 'LocationIconSvg'
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
  color: {
    type: String,
    default: '#000000'
  },
    width: {
        type: [String, Number],
        default: 24
    },
    height: {
        type: [String, Number],
        default: 24
    },
  strokeWidth: {
    type: [String, Number],
    default: 1.5
  },
  className: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ 
      width: __props.width + 'px', 
      height: __props.height + 'px',
      display: 'inline-block',
    })
  }, [
    (_openBlock(), _createElementBlock("svg", {
      width: __props.width,
      height: __props.height,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _createElementVNode("path", {
        d: "M14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9Z",
        stroke: __props.color,
        "stroke-width": __props.strokeWidth
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        d: "M18.2222 17C19.6167 18.9885 20.2838 20.0475 19.8865 20.8999C19.8466 20.9854 19.7999 21.0679 19.7469 21.1467C19.1724 22 17.6875 22 14.7178 22H9.28223C6.31251 22 4.82765 22 4.25311 21.1467C4.20005 21.0679 4.15339 20.9854 4.11355 20.8999C3.71619 20.0475 4.38326 18.9885 5.77778 17",
        stroke: __props.color,
        "stroke-width": __props.strokeWidth,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M13.2574 17.4936C12.9201 17.8184 12.4693 18 12.0002 18C11.531 18 11.0802 17.8184 10.7429 17.4936C7.6543 14.5008 3.51519 11.1575 5.53371 6.30373C6.6251 3.67932 9.24494 2 12.0002 2C14.7554 2 17.3752 3.67933 18.4666 6.30373C20.4826 11.1514 16.3536 14.5111 13.2574 17.4936Z",
        stroke: __props.color,
        "stroke-width": __props.strokeWidth
      }, null, 8, _hoisted_4)
    ], 8, _hoisted_1))
  ], 4))
}
}

})